import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateCases } from '@/modules/Case/gql/case.gql'
import { Case } from '@/modules/Case/interfaces/case'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchCase extends Vue {
  candidatesCase: Case[] = []

  get candidatesCaseNameOptions () {
    return this.candidatesCase.map(item => {
      return item.inquiryName
    })
  }

  get candidatesCaseOptions () {
    return this.candidatesCase.map(item => {
      return {
        id: +item.id,
        name: item.inquiryName
      }
    })
  }

  async getCandidateCases (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateCases,
        variables: {
          filter: {
            inquiryName: val
          },
          paging: {
            offset: 0,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesCase = result.data.getCases.cases
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
